<template>
  <div>
    <left-sidebar :ppa="ppa" />
    <right-sidebar :ppa="ppa" />
    <header-bp
      :user="user"
      :ppa="ppa"
    />
    <div class="header-spacer" />
    <div class="container">
      <div class="row main-categories">
        <main class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <h1>Exercises</h1>
        </main>
      </div>
      <div class="row">
        <div class="col col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="clients-grid">
            <ul
              v-if="cats && cats.length"
              class="cat-list-bg-style align-center sorting-menu"
            >
              <li
                v-for="item in cats"
                :key="item.id"
                class="cat-list__item"
                :class="{ active: item.id === selectedCatId }"
              >
                <a
                  href="#"
                  class=""
                  @click="selectCat(item.id)"
                >{{ item.title }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <exercise-list
        v-if="selectedCatId"
        :catid="selectedCatId"
      />
    </div>
    <a
      href="#"
      class="back-to-top"
    >
      <app-icon
        name="olymp-stats-arrow-icon"
        tooltip="Back to top"
        color="white"
        size="medium"
      />
    </a>
  </div>
</template>

<script>
import { format } from 'date-fns'
import { mapState } from 'vuex'

import LeftSidebar from '../../components/common-apps/common/LeftSidebar'
import RightSidebar from '../../components/common-apps/common/RightSidebar'
import HeaderBp from '../../components/common-apps/common/HeaderBp'
import ExerciseList from '../../components/mental/exercises/ExerciseList'
import AppIcon from "../../components/common-apps/common/AppIcon";
import exerciseStore from "../../store/modules/mental/exercise.js";

export default {
  name: 'Month',
  components: {
    LeftSidebar,
    RightSidebar,
    HeaderBp,
    ExerciseList,
    AppIcon
  },
  data () {
    return {
      date: new Date(),
      month: format(new Date(),'MM'),
      year: format(new Date(), 'yyyy')
    }
  },
  computed: mapState({
    cats: state => state.exercise ? state.exercise.cats : [],
    selectedCatId: state => state.exercise ? state.exercise.selectedCatId : 0,
    ppa: state => state.account.ppa,
    user () {
      return !this.$store.getters['account/user'] ? { username: 'None' } : this.$store.getters['account/user']
    }
  }),
  created () {
    if (this.$route.params.month1 && this.$route.params.year) {
      this.month = this.$route.params.month1
      this.year = this.$route.params.year
      this.date = new Date(`${this.year}-${this.month}-01T00:00:01`)
    }
    if (!this.$store.hasModule('exercise')) {
      this.$store.registerModule('exercise', exerciseStore)
    }
    this.$store.dispatch('exercise/getCats')
    this.$store.dispatch('account/fetchUser')
  },
  beforeDestroy () {
    this.$store.unregisterModule('exercise')
  },
  methods: {
    selectCat (catid) {
      this.$store.commit('exercise/setCatId', catid)
    }
  }
}

</script>

<style lang="scss">
  // Bootstrap from node_modules has container smaller
  @import '../../scss/Bootstrap/scss/bootstrap-reboot';
  @import '../../scss/Bootstrap/scss/bootstrap';
  @import '../../scss/Bootstrap/scss/bootstrap-grid';

  @import '../../scss/ticket';
  // @import '../../scss/fonts';

</style>
